export default __webpack_public_path__ + "static/media/twitter-alt.62d239f1.svg";